module.exports = __webpack_public_path__ + "img/report_banner3.a9e32a0c.png";